import { render, staticRenderFns } from "./AddFollowUpRecord.vue?vue&type=template&id=cad6c5de&scoped=true&"
import script from "./AddFollowUpRecord.vue?vue&type=script&lang=js&"
export * from "./AddFollowUpRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cad6c5de",
  null
  
)

export default component.exports